module.exports = __webpack_public_path__ + "static/img/Fwxp-dHW8lLyX.badb36d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/Fwxp-dHW8lLyX.png
// module id = SpPl
// module chunks = 16